import { motion } from 'framer-motion';
import React from 'react';

export const StepProgress = ({ progress, max }) => {
    return (
      <div className={`step-progress`}>
        {
          Array(max).fill(undefined).map((_, index) => (
            <motion.div
              key={index}
              className={`step ${index < progress ? 'active' : ''}`}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            />
          ))
        }
      </div>
    );
  }